import z from 'zod'

export type SigninValidateObject = z.infer<typeof signinValidateObject>

export const signinValidateObject = z.object({
  email: z
    .string()
    .min(0, { message: '入力してください' })
    .email({ message: 'メールアドレスの形式が正しくありません' }),
  password: z.string().min(0, { message: '入力してください' }),
})
